import { api } from "@king-ict/eupisi-ui/utils";

import { UpdateImportantDate } from "../../models/ImportantDate/ImportantDate";
import { SaveResult } from "../../models/Shared/SaveResult";

const apiUrlPrefix: string = "important-dates";

export const saveImportantDates = async (updateImportantDate: UpdateImportantDate) => {
    return api.put(
        `${apiUrlPrefix}`,
        updateImportantDate
    ) as Promise<SaveResult<UpdateImportantDate>>
}